import Card from '@ilg-totallymoney/ui/components/Card'

const UnscoredTableItemCard = ({
    children,
    id,
}: {
    children: React.ReactNode
    id: string
}) => (
    <Card
        hasBorder
        hasShadow={false}
        borderRadius="borderRadius30"
        p={['space20', 'space30']}
        data-testid={`unscored-table-item-${id}`}
        position="relative"
        overflow="hidden"
    >
        {children}
    </Card>
)

export default UnscoredTableItemCard
